import type { ReactNode } from 'react';

export const symbol_php: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-384v-194q0-9 7-15.5t16-6.5h129q20 0 34 14t14 34v64q0 20-14 34t-34 14H168v56q0 10-7 17t-17 7q-10 0-17-7t-7-17Zm258 0v-192q0-10 7-17t17-7q10 0 17 7t7 17v65h108v-65q0-10 7-17t17-7q10 0 17 7t7 17v192q0 10-7 17t-17 7q-10 0-17-7t-7-17v-79H426v79q0 10-7 17t-17 7q-10 0-17-7t-7-17Zm282 0v-194q0-9 7-15.5t16-6.5h129q20 0 34 14t14 34v64q0 20-14 34t-34 14H708v56q0 10-7 17t-17 7q-10 0-17-7t-7-17ZM168-488h104v-64H168v64Zm540 0h104v-64H708v64Z"
		/>
	</svg>
);
